import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="navbar-container">
      <div className="logo">
        <NavLink to="/" onClick={closeMenu}>
          <img src="/assets/WeprintLogo1.png" alt="WePrint Logo" />
        </NavLink>
      </div>
      {menuOpen && <div className="menu-overlay" onClick={closeMenu}></div>}
      <nav className={`nav-menu ${menuOpen ? 'open' : ''}`}>
        <ul onClick={closeMenu}>
          <li>
            <NavLink to="/" end className={({ isActive }) => isActive ? 'active' : ''}>
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to="/products" className={({ isActive }) => isActive ? 'active' : ''}>
              Products
            </NavLink>
          </li>
          <li>
            <NavLink to="/catalog" className={({ isActive }) => isActive ? 'active' : ''}>
              Catalog
            </NavLink>
          </li>
          <li>
            <NavLink to="/about" className={({ isActive }) => isActive ? 'active' : ''}>
              About
            </NavLink>
          </li>
          <li>
            <NavLink to="/testimonials" className={({ isActive }) => isActive ? 'active' : ''}>
              Testimonials
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact" className={({ isActive }) => isActive ? 'active' : ''}>
              Contact
            </NavLink>
          </li>
        </ul>
      </nav>

      <NavLink to="/contact#contact-form" className="cta-button" onClick={closeMenu}>
        GET IN TOUCH
      </NavLink>

      <div className="hamburger" onClick={toggleMenu}>
        <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
      </div>
    </header>
  );
}
